import { useEffect } from 'react'

export function Instructions() {
  useEffect(() => {
    // Load Twitter widgets script if not already loaded
    const twttr = (window as any).twttr
    if (!twttr) {
      const script = document.createElement('script')
      script.src = 'https://platform.twitter.com/widgets.js'
      script.async = true
      script.onload = () => {
        const loadedTwttr = (window as any).twttr
        if (loadedTwttr && loadedTwttr.widgets) {
          loadedTwttr.widgets.load()
        }
      }
      document.body.appendChild(script)
    } else {
      // If script is already loaded, just render the widgets
      twttr.widgets.load()
    }
  }, [])
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-white">
      <div className="max-w-4xl mx-auto px-4 py-12">
        {/* Hero Section */}
        <div className="text-center mb-12">
          <h1 className="hidden md:block text-5xl font-bold text-gray-900 mb-4">Blokadna Mreža - Širimo se</h1>
          <p className="text-xl text-gray-600 mb-3">Sistem za live koordinaciju građanskih akcija i pravovremene zaštite građana preko X (twitter) platforme</p>
          <div className="inline-block bg-blue-100 border border-blue-200 rounded-lg px-4 py-2">
            <p className="text-blue-800 font-semibold text-lg">Zajedno smo jači - pametniji se organizuje!</p>
          </div>
        </div>

        {/* Navigation Bar */}
        <div className="bg-white rounded-2xl shadow-lg mb-8 border border-gray-100 sticky top-4 z-10">
          <div className="flex justify-center gap-1 p-2 overflow-x-auto">
            <button
              onClick={() => document.getElementById('svrha')?.scrollIntoView({ behavior: 'smooth' })}
              className="px-2 py-1 md:px-4 md:py-2 bg-gray-100 hover:bg-gray-200 text-gray-700 font-medium rounded-lg transition-colors text-xs md:text-base whitespace-nowrap"
            >
              <span className="md:hidden">Svrha</span>
              <span className="hidden md:inline">Svrha</span>
            </button>
            <button
              onClick={() => document.getElementById('uputstva')?.scrollIntoView({ behavior: 'smooth' })}
              className="px-2 py-1 md:px-4 md:py-2 bg-gray-100 hover:bg-gray-200 text-gray-700 font-medium rounded-lg transition-colors text-xs md:text-base whitespace-nowrap"
            >
              <span className="md:hidden">Uputstva</span>
              <span className="hidden md:inline">Uputstva</span>
            </button>
            <button
              onClick={() => document.getElementById('primeri-tvitova')?.scrollIntoView({ behavior: 'smooth' })}
              className="px-2 py-1 md:px-4 md:py-2 bg-gray-100 hover:bg-gray-200 text-gray-700 font-medium rounded-lg transition-colors text-xs md:text-base whitespace-nowrap"
            >
              <span className="md:hidden">Tvitovi</span>
              <span className="hidden md:inline">Primeri tvitova</span>
            </button>
            <button
              onClick={() => document.getElementById('kontrolna-tabla')?.scrollIntoView({ behavior: 'smooth' })}
              className="px-2 py-1 md:px-4 md:py-2 bg-gray-100 hover:bg-gray-200 text-gray-700 font-medium rounded-lg transition-colors text-xs md:text-base whitespace-nowrap"
            >
              <span className="md:hidden">Tabla</span>
              <span className="hidden md:inline">Kontrolna tabla</span>
            </button>
            <button
              onClick={() => document.getElementById('primeri-pretraga')?.scrollIntoView({ behavior: 'smooth' })}
              className="px-2 py-1 md:px-4 md:py-2 bg-gray-100 hover:bg-gray-200 text-gray-700 font-medium rounded-lg transition-colors text-xs md:text-base flex items-center gap-1 whitespace-nowrap"
            >
              <span className="md:hidden">Primeri</span>
              <span className="hidden md:inline">Primeri pretraga</span>
              <span className="text-xs bg-yellow-200 text-yellow-800 px-1 md:px-2 py-0.5 rounded-full">WIP</span>
            </button>
          </div>
        </div>

        {/* Purpose Section */}
        <div id="svrha" className="bg-white rounded-2xl shadow-lg p-8 mb-8 border border-gray-100">
          <div className="flex items-center mb-4">
            <div className="bg-blue-100 p-3 rounded-full mr-4">
              <svg className="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
            <h2 className="text-2xl font-bold text-gray-900">Svrha sajta</h2>
          </div>
          <ul className="space-y-3 text-gray-700">
            <li className="flex items-start">
              <span className="text-blue-500 mr-2 mt-1">•</span>
              <span>Oglasite ili saznajte o <span className="bg-amber-100 font-semibold px-1 rounded">novim aktivnim blokadama</span> u svom kraju</span>
            </li>
            <li className="flex items-start">
              <span className="text-blue-500 mr-2 mt-1">•</span>
              <span>Prijavite ili saznajte o <span className="bg-amber-100 font-semibold px-1 rounded"> ugrožavanju bezbednosti gradjana</span> kako bi ih zaštitili</span>
            </li>
            <li className="flex items-start">
              <span className="text-blue-500 mr-2 mt-1">•</span>
              <span> Oglasite ili saznajte <span className="bg-amber-100 font-semibold px-1 rounded">o zborovima</span> u svojoj okolini i pridružite se borbi</span>
            </li>
            <li className="flex items-start">
              <span className="text-blue-500 mr-2 mt-1">•</span>
              <span><span className="bg-amber-100 font-semibold px-1 rounded">Saznajte o svojim pravima</span> u kontaktu sa državnim organima</span>
            </li>
          </ul>
        </div>

        {/* How to Contribute Section */}
        <div id="uputstva" className="bg-white rounded-2xl shadow-lg p-8 mb-8 border border-gray-100">
          <div className="flex items-center mb-6">
            <div className="bg-green-100 p-3 rounded-full mr-4">
              <svg className="w-6 h-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
              </svg>
            </div>
            <h2 className="text-2xl font-bold text-gray-900">Uputstva</h2>
          </div>
          
          {/* How system works */}
          <div className="mb-6">
            <p className="text-gray-700 text-lg mb-4">
              Naš sistem služi da brzo možete da delite aktuelne informacije svima koji mogu da pomognu. Sistem učitava objave sa platforme x.com.
            </p>
            <p className="text-gray-700 text-lg mb-4">
              Da biste nešto objavili, morate to učiniti sa svojim nalogom direktno na x.com. Hashtag-ovi su način na koji usklađujete tvit sa našom mrežom.
            </p>
          </div>
          
          {/* Basic Tag Instruction */}
          <div className="bg-green-50 border border-green-200 rounded-lg p-4 mb-6">
            <p className="text-green-800 text-base">
              Vaši tvitovi će biti učitani u naš sistem ako imaju u sebi hashtag: <span className="bg-green-200 px-3 py-1 rounded font-mono text-sm font-semibold">#sirimose</span>
            </p>
          </div>
          
          <p className="text-gray-700 mb-6 text-lg font-medium">Druge hashtag-ove dodajte za lakše pronalaženje:</p>
          
          {/* Location Section */}
          <div className="mb-6">
            <div className="bg-gray-50 rounded-lg p-5 border border-gray-200">
              <h4 className="font-bold text-gray-900 mb-3 text-lg flex items-center">
                <svg className="w-5 h-5 mr-2 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
                Lokacija:
              </h4>
              <div className="flex flex-wrap gap-2 mb-4">
                <span className="bg-gray-200 text-gray-800 px-3 py-1 rounded-full text-sm font-mono">#beograd</span>
                <span className="bg-gray-200 text-gray-800 px-3 py-1 rounded-full text-sm font-mono">#novisad</span>
                <span className="bg-gray-200 text-gray-800 px-3 py-1 rounded-full text-sm font-mono">#valjevo</span>
                <span className="bg-gray-200 text-gray-800 px-3 py-1 rounded-full text-sm font-mono">#ivanjica</span>
                <span className="bg-gray-200 text-gray-800 px-3 py-1 rounded-full text-sm font-mono">#zemun</span>
                <span className="bg-gray-200 text-gray-800 px-3 py-1 rounded-full text-sm font-mono">#gazela</span>
                <span className="bg-gray-200 text-gray-800 px-3 py-1 rounded-full text-sm font-mono">#brankovmost</span>
                <span className="bg-gray-200 text-gray-800 px-3 py-1 rounded-full text-sm font-mono">#autokomanda</span>
                <span className="bg-gray-200 text-gray-800 px-3 py-1 rounded-full text-sm font-mono">#ustanicka</span>
              </div>
              <div className="bg-gray-100 border border-gray-300 rounded-lg p-3">
                <p className="text-gray-800 text-sm">
                  Ako ste u većem mestu/gradu, stavite i ime grada (npr. beograd), i specifičnu lokaciju (npr. trošarina)
                </p>
              </div>
            </div>
          </div>
          
          {/* Thematic Section */}
          <div className="mb-6">
            <div className="bg-gray-50 rounded-lg p-5 border border-gray-200">
              <h4 className="font-bold text-gray-900 mb-3 text-lg flex items-center">
                <svg className="w-5 h-5 mr-2 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z" />
                </svg>
                Tematika:
              </h4>
              <div className="flex flex-wrap gap-2 mb-4">
                <span className="bg-gray-200 text-gray-800 px-3 py-1 rounded-full text-sm font-mono">#novablokada</span>
                <span className="bg-gray-200 text-gray-800 px-3 py-1 rounded-full text-sm font-mono">#dodjite</span>
                <span className="bg-gray-200 text-gray-800 px-3 py-1 rounded-full text-sm font-mono">#uzbuna</span>
                <span className="bg-gray-200 text-gray-800 px-3 py-1 rounded-full text-sm font-mono">#hapsenje</span>
                <span className="bg-gray-200 text-gray-800 px-3 py-1 rounded-full text-sm font-mono">#zandarmerija</span>
                <span className="bg-gray-200 text-gray-800 px-3 py-1 rounded-full text-sm font-mono">#nasilje</span>
                <span className="bg-gray-200 text-gray-800 px-3 py-1 rounded-full text-sm font-mono">#probijanje</span>
              </div>
              <div className="bg-gray-100 border border-gray-300 rounded-lg p-3">
                <p className="text-gray-800 text-sm">
                  Ako blokada tek počinje i treba još ljudi, stavite <span className="font-mono font-semibold">#novablokada</span>... ako je neka pretnja po sigurnost omladine, stavite <span className="font-mono font-semibold">#uzbuna</span> i koja vrsta pretnje tipa <span className="font-mono font-semibold">#batinasi</span>, <span className="font-mono font-semibold">#zandarmerija</span>
                </p>
              </div>
            </div>
          </div>
          
          {/* Media encouragement */}
          <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 flex items-start">
            <svg className="w-5 h-5 text-yellow-600 mr-3 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z" />
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 13a3 3 0 11-6 0 3 3 0 016 0z" />
            </svg>
            <p className="text-yellow-800 text-sm">
              Uključite <strong> media sadržaje (video i fotografije)</strong> kako bi se što lakše videlo i razumelo šta se tačno dešava + dokumentovati bilo kakve napade na građane i studente
            </p>
          </div>
        </div>

        {/* Tweet Examples Section */}
        <div id="primeri-tvitova" className="bg-white rounded-2xl shadow-lg p-8 mb-8 border border-gray-100">
          <div className="flex items-center mb-6">
            <div className="bg-green-100 p-3 rounded-full mr-4">
              <svg className="w-6 h-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z" />
              </svg>
            </div>
            <h2 className="text-2xl font-bold text-gray-900">Primeri tvitova</h2>
          </div>
          
          {/* Example 1 - New Blockade Announcement */}
          <div className="mb-3">
            <h4 className="font-semibold text-blue-800 mb-4 text-lg">Primer najave nove blokade</h4>
            <div className="grid md:grid-cols-3 gap-6 items-start">
              {/* Tags Section */}
              <div className="md:col-span-2">
                <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
                  <p className="text-blue-700 text-sm mb-3 font-medium">Preporučeni hashtags:</p>
                  
                  <div className="space-y-3">
                    <div>
                      <span className="text-xs text-blue-600 font-semibold uppercase tracking-wide mb-1 block">Osnovno:</span>
                      <span className="bg-blue-200 text-blue-800 px-3 py-1 rounded-full font-mono text-sm">#sirimose</span>
                    </div>
                    
                    <div>
                      <span className="text-xs text-blue-600 font-semibold uppercase tracking-wide mb-1 block">Lokacija:</span>
                      <div className="space-x-2">
                        <span className="bg-blue-200 text-blue-800 px-3 py-1 rounded-full font-mono text-sm">#beograd</span>
                        <span className="bg-blue-200 text-blue-800 px-3 py-1 rounded-full font-mono text-sm">#ustanicka</span>
                      </div>
                    </div>
                    
                    <div>
                      <span className="text-xs text-blue-600 font-semibold uppercase tracking-wide mb-1 block">Tematika:</span>
                      <div className="space-x-2">
                        <span className="bg-blue-200 text-blue-800 px-3 py-1 rounded-full font-mono text-sm">#novablokada</span>
                        <span className="bg-blue-200 text-blue-800 px-3 py-1 rounded-full font-mono text-sm">#dodjite</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              
              {/* Tweet Section */}
              <div className="md:col-span-1 flex justify-center">
                <div className="w-full max-w-[600px]">
                  <blockquote className="twitter-tweet" data-theme="light" data-width="600">
                    <p lang="sr" dir="ltr">
                      <a href="https://twitter.com/rajko_alt/status/1940102086558937102">
                        Pogledaj ovaj tvit
                      </a>
                    </p>
                  </blockquote>
                </div>
              </div>
            </div>
          </div>

          {/* Example 2 - Student Protection Alert */}
          <div className="mb-6">
            <h4 className="font-semibold text-red-800 mb-4 text-lg">Primer uzbune za zaštitu studenata</h4>
            <div className="grid md:grid-cols-3 gap-6 items-start">
              {/* Tags Section */}
              <div className="md:col-span-2">
                <div className="bg-red-50 border border-red-200 rounded-lg p-4">
                  <p className="text-red-700 text-sm mb-3 font-medium">Preporučeni hashtags:</p>
                  
                  <div className="space-y-3">
                    <div>
                      <span className="text-xs text-red-600 font-semibold uppercase tracking-wide mb-1 block">Osnovno:</span>
                      <span className="bg-red-200 text-red-800 px-3 py-1 rounded-full font-mono text-sm">#sirimose</span>
                    </div>
                    
                    <div>
                      <span className="text-xs text-red-600 font-semibold uppercase tracking-wide mb-1 block">Lokacija:</span>
                      <div className="space-x-2">
                        <span className="bg-red-200 text-red-800 px-3 py-1 rounded-full font-mono text-sm">#beograd</span>
                        <span className="bg-red-200 text-red-800 px-3 py-1 rounded-full font-mono text-sm">#pravnifakultet</span>
                      </div>
                    </div>
                    
                    <div>
                      <span className="text-xs text-red-600 font-semibold uppercase tracking-wide mb-1 block">Tematika:</span>
                      <div className="space-x-2">
                        <span className="bg-red-200 text-red-800 px-3 py-1 rounded-full font-mono text-sm">#zandarmerija</span>
                        <span className="bg-red-200 text-red-800 px-3 py-1 rounded-full font-mono text-sm">#uzbuna</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              
              {/* Tweet Section */}
              <div className="md:col-span-1 flex justify-center">
                <div className="w-full max-w-[600px]">
                  <blockquote className="twitter-tweet" data-theme="light" data-width="600">
                    <p lang="sr" dir="ltr">
                      <a href="https://twitter.com/blokadapravni/status/1940540058664403188">
                        Pogledaj ovaj tvit
                      </a>
                    </p>
                  </blockquote>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* How Dashboard Works Section */}
        <div id="kontrolna-tabla" className="bg-white rounded-2xl shadow-lg p-8 mb-8 border border-gray-100">
          <div className="flex items-center mb-4">
            <div className="bg-purple-100 p-3 rounded-full mr-4">
              <svg className="w-6 h-6 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>
            </div>
            <h2 className="text-2xl font-bold text-gray-900">Kako funkcioniše kontrolna tabla</h2>
          </div>
          
          <ul className="space-y-4 text-gray-700">
            <li className="flex items-start">
              <span className="bg-purple-200 text-purple-800 px-2 py-1 rounded-full text-sm font-bold mr-3 mt-0.5">1</span>
              <span>Automatski uključujemo sve što ima glavni hashtag <span className="bg-purple-100 px-2 py-1 rounded font-mono text-sm">#sirimose</span></span>
            </li>
            <li className="flex items-start">
              <span className="bg-purple-200 text-purple-800 px-2 py-1 rounded-full text-sm font-bold mr-3 mt-0.5">2</span>
              <span>Naš sistem zadržava sve tvitove sa više od 5 lajkova u prvih 15 minuta ili 20 lajkova u prvom satu na kontrolnoj tabli</span>
            </li>
            <li className="flex items-start">
              <span className="bg-purple-200 text-purple-800 px-2 py-1 rounded-full text-sm font-bold mr-3 mt-0.5">3</span>
              <span>Sistem se ažurira svakih 5 minuta i prikazuje tvitove ne starije od 36 sati</span>
            </li>
            <li className="flex items-start">
              <span className="bg-purple-200 text-purple-800 px-2 py-1 rounded-full text-sm font-bold mr-3 mt-0.5">4</span>
              <span>Možete pretraživati tagove da pronađete proteste u vašoj blizini kojima možete da se pridružite - foto ili video verifikacija u realnom vremenu je najbolji način potvrde</span>
            </li>
          </ul>
        </div>

        {/* Search Examples Section - WIP */}
        <div id="primeri-pretraga" className="bg-white rounded-2xl shadow-lg p-8 mb-8 border border-gray-100">
          <div className="flex items-center mb-6">
            <div className="bg-orange-100 p-3 rounded-full mr-4">
              <svg className="w-6 h-6 text-orange-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
              </svg>
            </div>
            <h2 className="text-2xl font-bold text-gray-900">
              Primeri pretraga
            </h2>
          </div>
          
          <p className="text-gray-700 mb-6">
            Monitor vam omogućava da pretražujete tvitove prema različitim kriterijumima kako biste brzo pronašli informacije koje su vam potrebne. Evo nekoliko primera kako možete koristiti pretragu:
          </p>

          {/* Example 1 - Recent attacks */}
          <div className="mb-8">
            <h4 className="font-semibold text-gray-800 mb-4 text-lg flex items-center">
              <span className="bg-red-100 text-red-800 px-3 py-1 rounded-full text-sm mr-3">Primer 1</span>
              Najskoriji napadi na građane
            </h4>
            <div className="grid md:grid-cols-2 gap-6 items-start">
              <div>
                <p className="text-gray-700 mb-3">
                  Za pronalaženje informacija o napadima ili incidentima, koristite kombinaciju ključnih reči:
                </p>
                <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-4">
                  <p className="text-red-700 text-sm mb-2 font-medium">Preporučene pretrage:</p>
                  <ul className="space-y-2 text-red-800">
                    <li className="flex items-center">
                      <span className="text-red-500 mr-2">•</span>
                      <span className="font-mono text-sm">#napad</span>
                    </li>
                    <li className="flex items-center">
                      <span className="text-red-500 mr-2">•</span>
                      <span className="font-mono text-sm">#uzbuna</span>
                    </li>
                    <li className="flex items-center">
                      <span className="text-red-500 mr-2">•</span>
                      <span className="font-mono text-sm">#nasilje</span>
                    </li>
                    <li className="flex items-center">
                      <span className="text-red-500 mr-2">•</span>
                      <span className="font-mono text-sm">#zandarmerija</span>
                    </li>
                  </ul>
                </div>
                <p className="text-gray-600 text-sm">
                  Monitor automatski sortira rezultate po vremenu, prikazujući najskorije tvitove prvo.
                </p>
              </div>
              <div className="flex justify-center">
                <img 
                  src="/primer-monitor-najskoriji-napadi.jpeg" 
                  alt="Primer pretrage najskorijih napada"
                  className="rounded-lg shadow-lg border border-gray-200 max-w-full"
                />
              </div>
            </div>
          </div>

          {/* Example 2 - Protests in my town */}
          <div className="mb-6">
            <h4 className="font-semibold text-gray-800 mb-4 text-lg flex items-center">
              <span className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm mr-3">Primer 2</span>
              Gde su blokade u mom gradu
            </h4>
            <div className="grid md:grid-cols-2 gap-6 items-start">
              <div>
                <p className="text-gray-700 mb-3">
                  Za pronalaženje aktivnih blokada u vašoj blizini, pretražujte po lokaciji:
                </p>
                <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-4">
                  <p className="text-blue-700 text-sm mb-2 font-medium">Preporučene pretrage:</p>
                  <ul className="space-y-2 text-blue-800">
                    <li className="flex items-center">
                      <span className="text-blue-500 mr-2">•</span>
                      <span className="font-mono text-sm">#[ime_vašeg_grada]</span>
                    </li>
                    <li className="flex items-center">
                      <span className="text-blue-500 mr-2">•</span>
                      <span className="font-mono text-sm">#novablokada</span>
                    </li>
                    <li className="flex items-center">
                      <span className="text-blue-500 mr-2">•</span>
                      <span className="font-mono text-sm">#dodjite</span>
                    </li>
                    <li className="flex items-center">
                      <span className="text-blue-500 mr-2">•</span>
                      <span className="font-mono text-sm">[ime_ulice/naselja]</span>
                    </li>
                  </ul>
                </div>
                <p className="text-gray-600 text-sm">
                  Kombinujte lokacijske tagove sa tematskim tagovima za precizniju pretragu.
                </p>
              </div>
              <div className="flex justify-center">
                <img 
                  src="/primer-monitor-blokada-u-mom-gradu.jpeg" 
                  alt="Primer pretrage blokada u gradu"
                  className="rounded-lg shadow-lg border border-gray-200 max-w-full"
                />
              </div>
            </div>
          </div>

          {/* Additional search tips */}
          <div className="bg-gray-50 border border-gray-200 rounded-lg p-5 mt-6">
            <h5 className="font-semibold text-gray-800 mb-3 flex items-center">
              <svg className="w-5 h-5 mr-2 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              Dodatni saveti za pretragu
            </h5>
            <ul className="space-y-2 text-gray-700 text-sm">
              <li className="flex items-start">
                <span className="text-gray-500 mr-2 mt-1">•</span>
                <span>Koristite <strong>kombinaciju tagova</strong> za precizniju pretragu (npr. #beograd #novablokada)</span>
              </li>
              <li className="flex items-start">
                <span className="text-gray-500 mr-2 mt-1">•</span>
                <span>Monitor prikazuje tvitove iz <strong>poslednjih 36 sati</strong></span>
              </li>
              <li className="flex items-start">
                <span className="text-gray-500 mr-2 mt-1">•</span>
                <span>Tvitovi sa <strong>foto/video dokazima</strong> su najpouzdaniji za verifikaciju</span>
              </li>
              <li className="flex items-start">
                <span className="text-gray-500 mr-2 mt-1">•</span>
                <span>Sistem se <strong>ažurira svakih 5 minuta</strong> sa najnovijim informacijama</span>
              </li>
            </ul>
          </div>
        </div>

        {/* CTA Button */}
        <div className="text-center mt-12">
          <a 
            href="#monitor"
            className="inline-block bg-blue-600 hover:bg-blue-700 text-white font-bold py-4 px-8 rounded-lg text-lg shadow-lg transform transition hover:scale-105"
          >
            Pogledaj Monitor →
          </a>
        </div>
      </div>
    </div>
  )
} 